import styled from 'styled-components';
import palette from 'palette';

export const StyledWimOperationalQualityWrapper = styled.div`
  padding: 24px;
  .ant-table-tbody {
    .percent-column {
      padding: 0 !important;
    }
  }
`;

export const HintTooltip = styled.div`
  max-width: 500px;
  font-size: 14px;
  color: ${palette.black.b2};
  white-space: 'pre-line';
`;

interface StyledPercentTextProps {
  percent: number;
}
const getCeillColor = (value: number) => {
  let color = palette.white.w1;
  if (value < 25) {
    color = palette.red.r7;
  } else if (value > 25 && value <= 50) {
    color = palette.red.r8;
  } else if (value > 50 && value <= 75) {
    color = palette.green.g11;
  } else if (value > 75) {
    color = palette.green.g10;
  }
  return color;
};
export const StyledPercentText = styled.div<StyledPercentTextProps>`
  padding: 12px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ percent }) => getCeillColor(percent)};
`;
